export default "__VITE_ASSET__DyNOMdLe__"